import { render, staticRenderFns } from "./SimuladorPassoPessoais.vue?vue&type=template&id=2ea6211b&"
import script from "./SimuladorPassoPessoais.vue?vue&type=script&lang=js&"
export * from "./SimuladorPassoPessoais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports